import type { Category, ToolId, CategoryIcon } from '../../types/tools'
import { MANTRAS } from '../../data/mantras'
import ICONS from '../../data/icons'
import { useAppSelector } from '../../store/hooks'

interface CategoryCardProps {
  categoryKey: string
  category: Category
  cardNumber: number
  onClick: () => void
}

export default function CategoryCard({ categoryKey, category, cardNumber, onClick }: CategoryCardProps) {
  const badges = useAppSelector((s) => s.ui.notificationBadges)
  const toolKeys = Object.keys(category.tools) as ToolId[]
  const mantra = MANTRAS[categoryKey] ?? ''
  const badgeCount = toolKeys.filter((tk) => badges[tk]).length
  const icon = ICONS[category.icon as CategoryIcon]
  const toolEntries = Object.entries(category.tools)

  return (
    <div
      className="dash-card"
      onClick={onClick}
      data-testid={`category-card-${categoryKey}`}
    >
      {badgeCount > 0 && (
        <div
          className="card-badge"
          title={`${badgeCount} tool${badgeCount === 1 ? '' : 's'} with active assignments`}
          data-testid={`category-badge-${categoryKey}`}
        >
          {badgeCount}
        </div>
      )}

      {/* Card header: icon row + title + mantra */}
      <div className="dash-card-header" data-testid={`category-header-${categoryKey}`}>
        <div className="dash-card-top-row">
          <div
            className="dash-card-icon"
            style={{ background: 'var(--blue-pl)', color: 'var(--blue)' }}
            data-testid={`category-icon-${categoryKey}`}
          >
            {icon}
          </div>
          <div className="dash-card-num">{cardNumber}</div>
        </div>
        <div className="dash-card-label" data-testid={`category-label-${categoryKey}`}>
          {category.label}
        </div>
        {mantra && (
          <div className="dash-card-mantra" data-testid={`category-mantra-${categoryKey}`}>
            &ldquo;{mantra}&rdquo;
          </div>
        )}
        <div className="dash-card-mantra-tag">Growth House Mantra</div>
      </div>

      {/* Tool list */}
      <div className="dash-card-tools" data-testid={`category-tools-${categoryKey}`}>
        {toolEntries.map(([toolKey, tool]) => (
          <div className="dash-card-tool" key={toolKey} data-testid={`dash-tool-${toolKey}`}>
            {badges[toolKey] && (
              <span
                className="notif-dot"
                title={badges[toolKey]}
                data-testid={`dash-tool-dot-${toolKey}`}
                style={{ marginRight: 6 }}
              />
            )}
            {tool.l}
          </div>
        ))}
      </div>
    </div>
  )
}
